import { render, staticRenderFns } from "./Block5.vue?vue&type=template&id=c1236000&scoped=true&"
import script from "./Block5.vue?vue&type=script&lang=js&"
export * from "./Block5.vue?vue&type=script&lang=js&"
import style0 from "./Block5.vue?vue&type=style&index=0&id=c1236000&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1236000",
  null
  
)

export default component.exports